import { render, staticRenderFns } from "./table-entry-edit.vue?vue&type=template&id=db4c321a"
import script from "./table-entry-edit.vue?vue&type=script&lang=js"
export * from "./table-entry-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports